<template>
    <div class="surgaltiinOrchin">
         <div class="container">
             <div class="row">
                 <div class="col-md-12">
                     <h3 class="title">Сургалтын орчин хэрэглэгдэхүүн</h3>
                 </div>
             </div>
             <div class="baiguulamj">
                 <div class="row">
                     <div class="col-md-12">
                         <h3 class="turul_name">Барилга байгууламж</h3>
                     </div>
                 </div>
                 <div class="row">
                      <div class="col-md-3">
                           <div class="dadlagiin_bair">
                               <div class="nummber">{{shcool.dadlagabair}}</div>
                               <img src="../assets/real-state.png" alt="">
                               <p>Дадлагын байр</p>
                           </div>
                      </div>
                      <div class="col-md-3">
                         <div class="dotuur_bair">
                             <div class="nummber">{{shcool.dotuurbair}}</div>
                             <img src="../assets/three-buildings.png" alt="">
                             <p>Дотуур байр</p>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="surgaltiin_bair">
                             <div class="nummber">{{shcool.surgaltiinbair}}</div>
                             <img src="../assets/school.png" alt="">
                             <p>Сургалтын байр</p>
                         </div>
                      </div>
                      <div class="col-md-3">
                         <div class="busad">
                             <div class="nummber">{{shcool.busad}}</div>
                             <img src="../assets/building.png" alt="">
                             <p>Бусад</p>
                         </div>
                      </div>
                 </div>
             </div>
             <div class="ded_butets">
                 <div class="row">
                     <div class="col-md-12">
                         <h3 class="ded_butets_name">Дэд бүтэц</h3>
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                               <div class="circle">{{shcool.tovlorson}}</div>
                               <p>Төвлөрсөн халаалттай</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.uuriinzuuh}}</div>
                             <p>Уурын зуухтай</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.shilennet}}</div>
                             <p>Шилэн кабелиар интернетэд <br>холбогдсон</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.angitanhim}}</div>
                             <p>Сургалтын анги танхим</p>
                         </div>
                     </div>
                 </div>
             </div>
             <div class="ded_butets">
                 <div class="row">
                     <div class="col-md-12">
                         <h3 class="ded_butets_name">Сургалтын хэрэглэгдэхүүн</h3>
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.suudliin}}</div>
                             <p>Суудлын автомашин</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.achaanii}}</div>
                             <p>Ачааны автомашин</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.simultor}}</div>
                             <p>Симулятор</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.jiipToo}}</div>
                             <p>Жийп</p>
                         </div>
                     </div>
                 </div>
                 <div class="row">
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.niitiinteever}}</div>
                             <p>Нийтийн тээвэр</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.tracktorToo}}</div>
                             <p>Трактор</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.zoovriin}}</div>
                             <p>Зөөврийн компьютер</p>
                         </div>
                     </div>
                     <div class="col-6 col-md-3">
                         <div class="ded_butets_item">
                             <div class="circle">{{shcool.suurincom}}</div>
                             <p>Суурин компьютер</p>
                         </div>
                     </div>
                 </div>
             </div>

         </div>
    </div>
</template>

<script>
    import {getSchoolItems} from "../api/index"
    export default {

        components: {

        },
        data () {
            return {
                shcool: {}
            }
        },
        mounted () {
            this.calldata();
        },
        methods: {
            calldata(){
                this.$isLoading(true);
                getSchoolItems().then(response=>{
                    this.shcool = response.data;
                    this.$isLoading(false);
                }).catch(error => {
                    this.$Loading.error();
                    console.log('ErrorL ', error);
                });
            },
        },

    }
</script>
